import React from 'react';

import Image from '../Image';
import {
  CtaWrapper,
  ImageOverlay,
  ImageWrapper,
  Split,
  StyledButtonLink,
  StyledContainer,
  Title,
  Wrapper,
} from './Banner.styles';

const Banner = ({ bannerData }) => {
  const { image, mainTitle, linkTitle, ctaUrl } = bannerData;

  return (
    <Wrapper>
      <ImageWrapper>
        <Image image={image[0]} />
        <ImageOverlay />
      </ImageWrapper>
      <StyledContainer>
        <Split>
          {mainTitle && <Title>{mainTitle}</Title>}
          {linkTitle && ctaUrl && (
            <CtaWrapper>
              <StyledButtonLink href={ctaUrl.url} type={ctaUrl.type} size="large">
                {linkTitle}
              </StyledButtonLink>
            </CtaWrapper>
          )}
        </Split>
      </StyledContainer>
    </Wrapper>
  );
};

export default Banner;
